module.exports = __webpack_public_path__ + "static/img/avatar-teacher-interview-default.58990178.png";